import { useQuery } from 'react-query';
import { apiService } from '@/src/services/api-service';
import { HOME_MOVES_ENDPOINTS } from './endpoints';
import {
  FetchMoveOutDataSuccessResponse,
  FetchMoveOutDataErrorResponse,
} from './types';

export function useHomeMoveStatusQuery(accountId?: string | null) {
  return useQuery<
    FetchMoveOutDataSuccessResponse,
    FetchMoveOutDataErrorResponse
  >(
    ['home-moves', 'status', accountId],
    async () => {
      if (!accountId) {
        throw new Error('Account ID is required');
      }

      const response = await apiService.get<FetchMoveOutDataSuccessResponse>({
        url: HOME_MOVES_ENDPOINTS.fetchMoveOutStatus(accountId),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    },
    {
      enabled: !!accountId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 3,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      onError: error => {
        console.error('Error fetching home move status:', error);
      },
    },
  );
}
